import { render } from "./PayTypeSelect.vue?vue&type=template&id=f374e66c"
import script from "./PayTypeSelect.vue?vue&type=script&lang=js"
export * from "./PayTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__